<label *ngIf="params.IsShowLabel">Insights :</label>
<div class="stock-cell">
    <app-restock-tags *ngIf="params.data.StockTag" [restockTag]="params.data.StockTag" ></app-restock-tags>
    {{params.value}}
</div>